import { render } from "./SkillsComponent.vue?vue&type=template&id=c1b03494&scoped=true&ts=true"
import script from "./SkillsComponent.vue?vue&type=script&lang=ts"
export * from "./SkillsComponent.vue?vue&type=script&lang=ts"

import "./SkillsComponent.vue?vue&type=style&index=0&id=c1b03494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b03494"]])

export default __exports__